import { IModuleConfig, ISlotConfig } from 'redux-state/layout/types.modules.js';

export const getMainWidthConfig = (hasLeftSlot: boolean, hasRightSlot: boolean): string => {
  if (hasLeftSlot && hasRightSlot) {
    return 'u-lg-width2of3 u-xl-width6of12';
  } else if (hasLeftSlot) {
    return 'u-lg-width2of3 u-xl-width9of12';
  } else if (hasRightSlot) {
    return 'u-lg-width1of1 u-xl-width9of12';
  }

  return 'u-width1of1';
};

export const hasModules = (section: ISlotConfig<'Raw'> | IModuleConfig[] = []): boolean => {
  if (Array.isArray(section)) {
    return section.length > 0;
  }
  return section.modules.length > 0;
};

export const DisplayWhenHasModules = ({
  section = [],
  children,
}: {
  section?: ISlotConfig<'Raw'> | IModuleConfig[];
  children: JSX.Element;
}) => {
  if (hasModules(section)) {
    return children;
  }
  return null;
};
